<template>
  <!-- Move an activity to another process (US 9369 + 9371): an activity belongs to one process, so this replaces
       the old Processes tab -->
  <b-modal ref="move"
           hide-header
           hide-footer
           modal-class="sx-confirm has-picker"
           qid="activity-move-dialog"
           @shown="loadProcesses('')">
    <div class="sx-confirm__head">
      <span class="sx-confirm__icon is-calm"><font-awesome-icon icon="exchange-alt"/></span>
      <div>
        <h3>{{ $t('activity_move.title', { name: activity.name }) }}</h3>
        <p>{{ process && process.name ? $t('activity_move.text', { name: process.name }) : $t('activity_move.text_none') }}</p>
      </div>
    </div>
    <div class="sx-confirm__body">
      <b-alert v-if="error" show variant="danger">{{ error }}</b-alert>
      <div class="v2-field">
        <label class="v2-field__label">{{ $t('activity_move.to') }}</label>
        <multiselect v-model="target"
                     :options="options"
                     :internal-search="false"
                     :loading="loading"
                     :placeholder="$t('activity_move.search')"
                     :select-label="$t('system.dropdown_select_label')"
                     :selected-label="$t('system.dropdown_selected_label')"
                     :deselect-label="$t('system.dropdown_deselect_label')"
                     label="name"
                     track-by="id"
                     qid="activity-move-process"
                     @search-change="loadProcesses">
          <template slot="noResult">{{ $t('system.no_results') }}</template>
        </multiselect>
      </div>
      <p class="sp-muted">{{ $t('activity_move.keeps') }}</p>
    </div>
    <div class="sx-confirm__foot">
      <b-button variant="secondary" qid="activity-move-cancel" @click="$refs.move.hide()">{{ $t('systems.delete.cancel') }}</b-button>
      <b-button variant="success"
                :disabled="busy || !target"
                qid="activity-move-submit"
                @click="move">
        <font-awesome-icon :icon="busy ? 'spinner' : 'exchange-alt'" :class="{ 'fa-spin': busy }"/> {{ $t('activity_move.submit') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';

  export default {
    name: 'ActivityMove',
    props: {
      activity: { type: Object, required: true },
      // Its process now, if it has one
      process: { type: Object, default: null }
    },
    data() {
      return {
        target: null,
        options: [],
        loading: false,
        busy: false,
        error: '',
        searchTimer: null
      };
    },
    computed: {
      getClient() {
        return this.$store.state.client;
      }
    },
    methods: {
      show() {
        this.target = null;
        this.error = '';
        this.$refs.move.show();
      },
      loadProcesses(query) {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => {
          let current = this.process ? this.process.id : null;
          this.loading = true;
          piincHttp.get('processes', { params: {
            client: this.getClient.slug,
            keyword: query || undefined,
            per_page: 100
          } }).then(response => {
            this.loading = false;
            this.options = (response.data.items || []).filter(process => process.id !== current);
          }, () => {
            this.loading = false;
          });
        }, query ? 250 : 0);
      },
      // Logged on the activity (moved) and on both processes (removed / added) by the backend
      move() {
        this.busy = true;
        this.error = '';
        piincHttp.put('activities/' + this.activity.slug + '/process', { process: this.target.slug }).then(() => {
          this.busy = false;
          this.$refs.move.hide();
          this.$toastr('success', this.$t('activity_move.done', { name: this.target.name }));
          this.$emit('moved', this.target);
        }, error => {
          this.busy = false;
          this.error = (error && error.data && error.data.message) || this.$t('system_hero.panel.error');
        });
      }
    }
  };
</script>
